import React, { useState } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import './Support.scss';

const faqs = [
    {
        q: 'What is LiftLog?',
        a: 'LiftLog is a workout tracking app for iOS that helps you log exercises, track sets and reps, monitor your progress over time, and hit new personal records.',
    },
    {
        q: 'Is LiftLog free to use?',
        a: 'LiftLog is free to download and use. Some premium features may require a subscription, managed through the Apple App Store.',
    },
    {
        q: 'How do I log a workout?',
        a: 'Tap "Workout" from the bottom navigation, add exercises from the exercise library, then enter your sets, weight, and reps. Tap "Finish Workout" when you\'re done.',
    },
    {
        q: 'Can I create custom workout templates?',
        a: 'Yes! You can create templates with your favorite exercises and a preset number of sets. Start any session from a template to save time.',
    },
    {
        q: 'How does progress tracking work?',
        a: 'LiftLog automatically tracks your weekly workouts, total volume, and personal records. The Progress tab shows charts for weight, volume, and estimated 1RM for each exercise.',
    },
    {
        q: 'What are Muscle Insights?',
        a: 'Muscle Insights shows which muscle groups you train most and least, helping you balance your routine and avoid neglecting any body part.',
    },
    {
        q: 'Can I filter exercises by muscle group?',
        a: 'Yes. The exercise library lets you filter by muscle group — chest, back, shoulders, biceps, triceps, legs, glutes, core, and more.',
    },
    {
        q: 'How do I delete my account and data?',
        a: 'You can delete your account through the in-app settings or by contacting us at evolvedevlabs@gmail.com. All associated data will be permanently removed.',
    },
    {
        q: 'Is my data secure?',
        a: 'Yes. Your data is securely stored using Supabase with industry-standard encryption. We never sell or share your personal data.',
    },
    {
        q: 'What devices does LiftLog support?',
        a: 'LiftLog is currently available on iOS (iPhone). Android support may be added in the future.',
    },
];

const FAQItem = ({ q, a }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="faq-item">
            <div
                className={`faq-question ${open ? 'open' : ''}`}
                onClick={() => setOpen(!open)}
            >
                {q}
                <span className="faq-toggle">+</span>
            </div>
            {open && (
                <div className="faq-answer">{a}</div>
            )}
        </div>
    );
};

const Support = () => (
    <div className="liftlog-support">
        <header className="support-header">
            <Container maxWidth="md">
                <Link to="/liftlog" className="support-back">&larr; Back to LiftLog</Link>
                <span className="support-badge">LiftLog</span>
                <Typography variant="h4" sx={{ color: '#fff', fontWeight: 700 }}>
                    Support
                </Typography>
            </Container>
        </header>

        <Container maxWidth="md" className="support-content">
            {/* FAQ */}
            <section className="faq-section">
                <Typography variant="h5" className="faq-title">
                    Frequently Asked Questions
                </Typography>
                {faqs.map((faq, i) => (
                    <FAQItem key={i} q={faq.q} a={faq.a} />
                ))}
            </section>

            {/* Contact */}
            <section className="contact-section">
                <Typography variant="h5" className="contact-title">
                    Still Need Help?
                </Typography>
                <Typography className="contact-desc">
                    We're here to help. Reach out with any questions, feedback, or issues.
                </Typography>
                <a href="mailto:evolvedevlabs@gmail.com" className="contact-email">
                    evolvedevlabs@gmail.com
                </a>
            </section>

            {/* Footer links */}
            <Box className="support-footer">
                <Link to="/liftlog">Home</Link>
                <Link to="/liftlog/privacy">Privacy Policy</Link>
                <Link to="/liftlog/terms">Terms &amp; Conditions</Link>
            </Box>
        </Container>
    </div>
);

export default Support;
